export const cacheAsyncValidation = (asyncValidate: (value: string) => Promise<boolean>) => {
  let isValid = false
  let cachedValue = ''

  return async (currentValue?: string) => {
    if (cachedValue !== currentValue && currentValue !== undefined) {
      const result = await asyncValidate(currentValue)
      isValid = result
      cachedValue = currentValue
    }

    return isValid
  }
}
